import React from "react";

interface Props {
  readonly color?: string;
  readonly size?: number;
}

const IdIcon: React.FC<Props> = ({ color = "#79808A", size = 20 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.704 12.336V4.656H3.656V5.296H2.48V11.696H3.656V12.336H1.704ZM4.43056 11V5.168H5.30256V11H4.43056ZM6.71963 11V5.168H9.07963C10.7596 5.168 11.7196 6.336 11.7196 8.088C11.7196 9.84 10.7596 11 9.07963 11H6.71963ZM7.59163 10.248H8.95163C10.0796 10.248 10.8236 9.552 10.8236 8.072C10.8236 6.592 10.0716 5.92 8.95163 5.92H7.59163V10.248ZM14.0553 4.656V12.336H12.1033V11.696H13.2793V5.296H12.1033V4.656H14.0553Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default IdIcon;
